import { Box } from 'braid-design-system';
import React from 'react';

import * as styles from './DropdownDivider.css';

export const DropdownDivider = () => (
  <Box paddingY="small">
    <Box className={styles.dropdownDividerBar} />
  </Box>
);
